$.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on("scroll", function () {
    $('video').each(function(){
        if (!$(this).isInViewport()) {
            $(this)[0].muted = true;
        }
    })
});

$(document).on("ready",function() {
    $(".video-container").each( setup_video_controls );
  console.log('123');
});
//
$('#triangle-popover').on('shown.bs.popover', function () {
    $("#riding-triangle").each(setup_video_controls)
    // $("#riding-triangle").each(setup_video_controls)
  })

var is_iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
var is_safari = window.safari !== undefined;


function setup_video_controls(template_div_id /* optional - id of the template div */) {
    
    template_div_id = template_div_id || "templates";
    template_div_id = "#" + template_div_id;
  
    var $video_container = $(this);
    var video = $("video", this), //jquery video element
        $video = video[0]; // DOM video element

    if (!$video) {
        console.log("Couldn't set up video controls since no video tag found");
        return;
    }

    // first, set up the templatized controls
    // $(template_div_id + " .video-controls").clone(true).insertAfter($video);
    //append to
   // $(template_div_id + " .video-controls").clone(true).appendTo(".video-container");

    // find all .video-containers which have one video tag and NO video-controls tag 
    var selected = $(".video-container").filter(function (index) {
        return $("video", this).length === 1 && $(".video-controls", this).length === 0;
    });
    $(template_div_id + " .video-controls").clone(true).appendTo($(selected));
    
    // Video Controls
    var $video_controls = $video_container.find(".video-controls");
    var $button_controls = $(this).find(".bottom-wrapper");
    var $progress_bar = $(this).find(".progress-bar");
    var $progress = $(this).find(".time-bar");
    var $buffer_bar = $(this).find(".buffer-bar");
    var $play_button = $(this).find(".play-button");
    var $mute_button = $(this).find(".sound-button");

    var $volume_wrapper = $(this).find(".volume");
    var $volume_bar = $(this).find(".volume-bar");

    var $full_screen_btn = $(this).find(".btnFS");
    var $current = $(this).find(".current");
    var $duration = $(this).find(".duration");

    var pause_btn_img = "https://cdn.shopify.com/s/files/1/0526/2688/2746/files/pause-btn-skew.png",
        play_btn_img = "https://cdn.shopify.com/s/files/1/0526/2688/2746/files/play-btn-skew.png",
        muted_img = "https://cdn.shopify.com/s/files/1/0526/2688/2746/files/video-mute-skew.png",
        unmuted_img = "https://cdn.shopify.com/s/files/1/0526/2688/2746/files/audio-img-skew.png",
        expand_img = "https://cdn.shopify.com/s/files/1/0526/2688/2746/files/expand-yellow.png",
        unexpand_img = "https://cdn.shopify.com/s/files/1/0526/2688/2746/files/unexpand.png";

    // first, let's set the proper display state based on the video state
    display_controls_state();
    video.on("play", display_controls_state);
    video.on("webkitendfullscreen", display_controls_state);
    video.on("pause", display_controls_state);
    video.on("volumechange", display_controls_state);
    $(document).on("fullscreenchange", display_controls_state);

    
    /*
    ** query the video object and display the state of the different controls
    */
    function display_controls_state() {

        // pause/play button 
        $play_button.attr("src", $video.paused ? play_btn_img : pause_btn_img);

        // mute / unmute button and volume bar
        $mute_button.attr("src", $video.muted || $video.volume === 0 ? muted_img : unmuted_img);
        var vol_percent = $video.volume * 100;
        $volume_bar.css("width", $video.muted ? "0%" : vol_percent + "%");

        // fullscreen expand/collapse
        $full_screen_btn.attr("src", document.fullscreenElement ? unexpand_img : expand_img);

    }

    // Video

    // Toggles play/pause for the video
    function playVideo() {
        if ($video.paused) {
            $video.play();
        } else {
            $video.pause();
        }
        display_controls_state();
    }

    // volume control
    $volume_wrapper.on("input", function() {
        $video.volume = $(this).val() / 100;
    });

    function time_format(seconds) {
        var m = Math.floor(seconds / 60) < 10
            ? "0" + Math.floor(seconds / 60)
            : Math.floor(seconds / 60);
        var s = Math.floor(seconds - m * 60) < 10
            ? "0" + Math.floor(seconds - m * 60)
            : Math.floor(seconds - m * 60);
        return m + ":" + s;
    }

    function startBuffer() {
        $current_buffer = $video.buffered.end[0];
        $max_duration = $video.duration;
        $perc = 100 * $current_buffer / $max_duration;
        $buffer_bar.css("width", $perc + "%");

        if ($current_buffer < $max_duration) {
            setTimeout(startBuffer, 500);
        }
    }

    function updatebar(x) {
        $position = x - $progress.offset().left;
        $percentage = 100 * $position / $progress_bar.width();
        if ($percentage > 100) {
            $percentage = 100;
        }
        if ($percentage < 0) {
            $percentage = 0;
        }
        $progress.css("width", $percentage + "%");
        $video.currentTime = $video.duration * $percentage / 100;
    }

    video.on("loadedmetadata", function () {
        $current.text(time_format(0));
        $duration.text(time_format($video.duration));
        $video.volume = 0.5;
        setTimeout(startBuffer, 150);
    });

    // // Play/pause on video click
    // video.click(function() {
    //   playVideo();
    // });

    // Video duration timer
    video.on("timeupdate", function () {
        $current.text(time_format($video.currentTime));
        $duration.text(time_format($video.duration));
        var currentPos = $video.currentTime;
        var maxduration = $video.duration;
        var perc = 100 * $video.currentTime / $video.duration;
        $progress.css("width", perc + "%");
    });

    /* VIDEO CONTROLS
          ------------------------------------------------------- */

    // Hide button controls when video is playing
    $video_container.on("mouseleave", function () {
        if ($video.paused === false) {
            $video_container.addClass("playing");
        }
    });

    // Show button controls on hover
    $video_container.on("mouseover", function () { });

    // Play/pause on button click
    $play_button.click(function () {
        playVideo();
    });

    // Mute video on button click
    $mute_button.click(function () {
        if ($video.muted) {
            $("video").prop('muted', true); // first mute all the videos on the page
            $video.muted = false; // unmute me
        } else 
            $video.muted = true; // mute me
        display_controls_state();
    });

    // Full Screen Button
    $full_screen_btn.click(function() {

        // first check for iphone. we need to work on the video element
        if ((is_iOS || is_safari) && $video.webkitSupportsFullscreen) {
            if ($video.webkitDisplayingFullscreen) {
                $video.webkitExitFullscreen();
                $("#video-hero").css({"padding-top":"80px"});
            } else {
                $video.webkitEnterFullscreen();
                $("#video-hero").css({"padding-top":"0px"});
            }
            return;
        }

        // okay - now we can try for other browsers
        if (document.fullscreenElement) {
            document.exitFullscreen();
            $("#video-hero").css({"padding-top":"80px"});
        }
        else {
            var container = $video_container[0];
            container.requestFullscreen();
            $("#video-hero").css({"padding-top":"0px"});
        }
    });


    // VIDEO PROGRESS BAR
    //when video timebar clicked
    var timeDrag = false; /* check for drag event */
    $progress_bar.on("mousedown", function (e) {
        timeDrag = true;
        updatebar(e.pageX);
    });
    $(document).on("mouseup", function (e) {
        if (timeDrag) {
            timeDrag = false;
            updatebar(e.pageX);
        }
    });
    $(document).on("mousemove", function (e) {
        if (timeDrag) {
            updatebar(e.pageX);
        }
    });

    $video.onended = function () {
        display_controls_state();
    };

    function launchFullscreen(ele) {
        if (!ele) return;

        if (ele.requestFullscreen) {
            ele.requestFullscreen();
        } else if (ele.mozRequestFullScreen) {
            ele.mozRequestFullScreen();
        } else if (ele.webkitRequestFullscreen) {
            ele.webkitRequestFullscreen();
        } else if (ele.msRequestFullscreen) {
            ele.msRequestFullscreen();
        } else if (ele.webkitEnterFullscreen) {
            ele.webkitEnterFullscreen();
        }
    };

    


}




